import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Player,
  Video,
  classNames,
  Pressable,
} from "@gonoodle/gn-universe-ui";

export default function Transmogrifier({
  title,
  jwPlayerId,
  award,
  isOpen,
  action,
  onActionClick,
  onPrintAward,
}) {
  const [showActions, setShowActions] = React.useState(false);
  // award prop is cached as the champ data is stored inside the user object so updates to the user object will the Transmogrifier is open will bring the next level award.
  const cachedAward = React.useRef(award);

  React.useEffect(() => {
    if (!isOpen) {
      setShowActions(false);
    }
  }, [isOpen]);

  return (
    <Modal className="z-50 items-stretch" isOpen={isOpen}>
      <div className="absolute inset-0 bg-white gn-transmogrifier-video">
        <Player
          unsafeOptions={{
            autostart: true,
            stretching: "fill",
          }}
          hideControls
        >
          <Video
            options={{
              source: jwPlayerId,
            }}
            onVideoStart={() => {
              setTimeout(() => setShowActions(true), 5000);
            }}
          />
        </Player>

        <div
          className={classNames(
            "opacity-0 transition-opacity",
            showActions && "opacity-100",
          )}
        >
          <h1 className="absolute left-1/2 -translate-x-1/2 top-10 w-full text-white text-xl sm:text-2xl lg:text-3xl text-center font-display">
            {title}
          </h1>

          <div
            className={classNames(
              "absolute w-full left-0 bottom-0 flex",
              "bg-gradient-to-b from-transparent to-black",
              "max-sm:flex-col max-sm:items-center max-sm:space-y-sm max-sm:pb-4 max-sm:px-4",
              "sm:justify-center sm:space-x-md pt-32 sm:pb-10 sm:px-10",
            )}
          >
            {cachedAward.current && (
              <Pressable
                onPress={onPrintAward}
                elementType="a"
                className={classNames(
                  "w-full py-2 sm:w-72 sm:py-4 rounded-md bg-white font-bold text-center transition",
                  "flex justify-center items-center",
                  "hover:bg-purple hover:border-purple hover:text-white",
                  "focus:bg-purple focus:border-purple focus:text-white",
                )}
                href={cachedAward.current}
                target="_blank"
                rel="noopener noreferrer"
              >
                Print Award
              </Pressable>
            )}

            <button
              className={classNames(
                "w-full py-2 sm:w-72 sm:py-4 border-white border-2 rounded-md text-white font-bold transition",
                "flex justify-center items-center",
                "hover:bg-white hover:text-black",
                "focus:bg-white focus:text-black",
              )}
              onClick={onActionClick}
            >
              {action}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

Transmogrifier.propTypes = {
  title: PropTypes.string.isRequired,
  jwPlayerId: PropTypes.string.isRequired,
  award: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  action: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired,
  onPrintAward: PropTypes.func,
};

Transmogrifier.defaultProps = {
  award: undefined,
  onPrintAward: () => {},
};
